var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid"},[_c('div',{staticClass:"navbar"},[_c('nav-bar',{key:_vm.getProjectId})],1),_c('div',{staticClass:"sidebar"},[_c('sidebar')],1),(!_vm.isLogin)?_c('div',{staticClass:"breadcrumbWrapper"},[_c('breadcrumb')],1):_vm._e(),_c('div',{staticClass:"content"},[_c('router-view',{key:_vm.getProjectId})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }